import { render, staticRenderFns } from "./ActiveDiscounts.vue?vue&type=template&id=3d5d676c"
import script from "./ActiveDiscounts.vue?vue&type=script&lang=js"
export * from "./ActiveDiscounts.vue?vue&type=script&lang=js"
import style0 from "./ActiveDiscounts.vue?vue&type=style&index=0&id=3d5d676c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports